<div class="d-flex justify-content-between">
  <!--Add Single Step-->
  <button
    type="button"
    class="btn btn-outline-warning btn-sm ag_grid_row_btn form-control py-0"
    tooltip="Edit Firearm"
    placement="right"
    (click)="editFirearmClick()"
  >
  <i class="fa-solid fa-pen"></i>
  </button>

  <!--Delete Single Step-->
  <button
    type="button"
    class="btn btn-outline-danger btn-sm ag_grid_row_btn form-control py-0"
    style="margin-left: 2px; margin-right: 2px; color: indianred !important"
    tooltip="Delete Firearm"
    placement="right"
    (click)="deleteFirearmClick()"
  >
  <i class="fa-solid fa-trash-can"></i> 
  </button>
</div>
